import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const BarrierConstruction = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M30 8.999C30 7.345 28.654 6 27 6H5C3.346 6 2 7.346 2 9V15V17C2 18.654 3.346 20 5 20H8V23C8 23.551 7.551 24 7 24H5C4.448 24 4 24.448 4 25C4 25.552 4.448 26 5 26H7C8.654 26 10 24.654 10 23V20H22V23C22 24.654 23.346 26 25 26H27C27.552 26 28 25.552 28 25C28 24.448 27.552 24 27 24H25C24.449 24 24 23.551 24 23V20H27C28.654 20 30 18.654 30 17V9V8.999ZM27.936 8.65L18.586 18H11.415L21.415 8H27.001C27.429 8 27.794 8.271 27.937 8.65H27.936ZM5 8H8.586L4 12.586V9C4 8.449 4.449 8 5 8ZM4 17V15.414L11.414 8H18.585L8.585 18H4.999C4.448 18 3.999 17.551 3.999 17H4ZM27 18H21.414L28 11.414V17C28 17.551 27.551 18 27 18Z" />
	</svg>
);

export default BarrierConstruction;
